/** Visitor mode is on only when an admin has set this to the string false. */
export function isVisitorMode(settings) {
    return settings?.require_guest_identity === "false";
}
//# sourceMappingURL=visitorMode.js.map